import { createHistory } from 'history';

const sharedHistory = createHistory();

export default sharedHistory;
